import { indexItems } from '@/mocks/homeData';

const bgClasses: Record<number, string> = {
  0: 'bg-primary-100',
  1: 'bg-accent-100',
  2: 'bg-secondary-100',
  3: 'bg-primary-100',
  4: 'bg-accent-100',
  5: 'bg-secondary-100',
  6: 'bg-primary-100',
  7: 'bg-accent-100',
};

const iconClasses: Record<number, string> = {
  0: 'text-primary-500',
  1: 'text-accent-500',
  2: 'text-secondary-500',
  3: 'text-primary-500',
  4: 'text-accent-500',
  5: 'text-secondary-500',
  6: 'text-primary-500',
  7: 'text-accent-500',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">内容导航</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">网址导航</h2>
          <p className="mt-2 text-foreground-600 text-sm">快速找到您感兴趣的黑料资讯分类频道</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={item.id}
              href="#"
              className="group bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer flex flex-col items-center text-center"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${bgClasses[idx]}`}>
                <i className={`${item.icon} text-xl ${iconClasses[idx]}`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{item.desc}</p>
              <span className="mt-2 text-[11px] text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}